import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UserModel } from '../../../users/models/users.model';
import { AuthService } from '../../../../core/services/auth.service';
import { SystemUserRoles } from '../../../../core/helpers/user-roles.helper';

@Component({
  selector: 'app-user-picker',
  standalone: false,
  templateUrl: './user-picker.component.html',
  styleUrl: './user-picker.component.scss'
})
export class UserPickerComponent implements OnInit, OnChanges {
  @Input() allUsers: UserModel[] = [];
  @Input() selectedUser: UserModel | null = null;
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  @Output() onUserChanged = new EventEmitter<UserModel>();
  filteredUsers: UserModel[] = [];
  searchText = '';
  showDropdown = false;
  editing = false;

  constructor(private el: ElementRef, private authService: AuthService) { }

  ngOnInit() {
    this.filteredUsers = [...this.allUsers];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedUser'] && this.selectedUser) {
      this.searchText = this.selectedUser.fullname;
      this.stopEditing();
    }
  }

  ngAfterViewInit() {
    if (!this.selectedUser) {
      this.startEditing();
    }
  }

  async startEditing() {
    var isClient = await this.authService.hasPermission(SystemUserRoles.CLIENT_NAME);
    if (!isClient) {
      this.editing = true;
      setTimeout(() => this.searchInput.nativeElement.focus());
    }
  }

  stopEditing() {
    this.editing = false;
  }

  onFocus() {
    this.showDropdown = true;
    this.filterUsers();
  }

  onInput() {
    this.filterUsers();
    this.showDropdown = true;
  }

  filterUsers() {
    const val = this.searchText.toLowerCase();
    this.filteredUsers = this.allUsers.filter(u =>
      u.fullname.toLowerCase().includes(val) ||
      u.email.toLowerCase().includes(val)
    );
  }

  selectUser(user: UserModel) {
    this.selectedUser = user;
    this.searchText = user.fullname;
    this.showDropdown = false;
    this.onUserChanged.emit(this.selectedUser);
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: HTMLElement) {
    if (!this.el.nativeElement.contains(target)) {
      this.showDropdown = false;
    }
  }
}